module.exports = __webpack_public_path__ + "static/media/ziranmei2.9fa689e1.png";